import React, { PropsWithChildren } from 'react';
import { cxTw } from '@asigna/kit';
import { uniqueId } from 'lodash';

type Props<TKey extends string> = {
  id: TKey;
  disabled?: boolean;
  isActive: boolean;
  onClick: (tab: TKey) => void;
  className?: string;
};

export const Tab = <TKey extends string>({
  id,
  children,
  isActive,
  disabled,
  onClick,
  className,
}: PropsWithChildren<Props<TKey>>) => (
  <button
    onClick={() => onClick(id)}
    disabled={disabled}
    className={cxTw(
      'px-20 py-4 rounded-[40px] border h-36 shrink-0 text-r13 flex items-center gap-x-[8px]',
      isActive
        ? 'bg-primary-10 border-primary text-white'
        : 'bg-black-2 hover:bg-white-10 border-white-10 hover:border-black-3 text-regular transition-all',
      disabled && 'text-white-30',
      className
    )}
    key={uniqueId(id)}
  >
    {children || id}
  </button>
);
